import { Field, reduxForm, SubmissionError } from "redux-form";
import { toastr } from "react-redux-toastr";
import { Button, Input } from "expano-components";

import { Dashboard } from "components";

import useCreate from "hooks/useCreate";
import useUpdate from "hooks/useUpdate";
import available_languages_options from "utils/select_options/available_languages";
import { useMemo } from "react";

const InputField = (props) => <Input {...props} />;

const NameTranslations = ({
  product_id,
  refetch,
  handleSubmit,
  pristine,
  invalid,
}) => {
  const { is_updating, update } = useUpdate({
    path: `/products/${product_id}`,
    onSuccess: refetch,
    onError: (err) => {
      throw new SubmissionError(err);
    },
  });

  const onSubmit = (values) => update(values);

  const { is_creating: is_translating, create: translateMissing } = useCreate({
    path: `/products/${product_id}/translate_missing_names`,
    success_message_enabled: false,
    onSuccess: (data) => {
      if (data?.message) {
        toastr.warning("Częściowe tłumaczenie", data.message);
      } else {
        toastr.success("Sukces", "Przetłumaczono brakujące nazwy");
      }
      refetch();
    },
    onError: () => refetch(),
  });

  const languages = useMemo(
    () =>
      available_languages_options
        .filter(({ value }) => value !== "pl")
        .map(({ value, label }) => ({
          value,
          label,
        })),
    [available_languages_options],
  );

  return (
    <Dashboard
      header={{
        title: "Tłumaczenia nazwy produktu",
        icon: "info",
        aside: (
          <button
            type="button"
            className="btn btn-sm btn-blue"
            disabled={is_translating || is_updating}
            onClick={() => translateMissing()}
          >
            <span>
              {is_translating ? "Tłumaczenie..." : "Tłumacz brakujące"}
            </span>
          </button>
        ),
      }}
      footer={
        <Button
          type="save"
          text={is_updating ? "Proszę czekać..." : "Zapisz"}
          disabled={pristine || invalid || is_updating || is_translating}
          onClick={handleSubmit(onSubmit)}
        />
      }
    >
      <form
        className="dashboard__form"
        onSubmit={handleSubmit(onSubmit)}
        noValidate
      >
        <div className="row wrap">
          {languages.map(({ value, label }) => (
            <div className="box-6 m-b-10" key={value}>
              <Field
                name={`name_${value}`}
                label={`Nazwa produktu (${label})`}
                prefix={value}
                component={InputField}
                type="text"
              />
            </div>
          ))}
        </div>
      </form>
    </Dashboard>
  );
};

const form = "update-product-name-translations";

export default reduxForm({ form, enableReinitialize: true })(NameTranslations);
